import { computed, inject, Injectable } from "@angular/core";
import { UserStore } from "./user.store";

@Injectable({
    providedIn: 'root'
})
export class UserFacade {

    private store = inject(UserStore)

    readonly clinic_id = computed(() => this.store.clinic_id())
    readonly provider_id = computed(() => this.store.provider_id())
    readonly onboarding_status = computed(() => this.store.onboarding_status())
    readonly licence_expire_date = computed(() => this.store.licence_expire_date())
    readonly insurance_expire_date = computed(() => this.store.insurance_expire_date())
    readonly has_expired_documents = computed(() => this.store.has_expired_documents())

    setLoading(loading: boolean) {
        this.store.setLoading(loading)
    }

    setClinicId(clinic_id: number) {
        this.store.setClinicId(clinic_id)
    }

    setProviderId(provider_id: number) {
        this.store.setProviderId(provider_id)
    } 

    setOnboardingStatus(onboarding_status: number) {
        this.store.setOnboardingStatus(onboarding_status)
    }

    setExpiryDates(params: {
        licence_expire_date?: string | null,
        insurance_expire_date?: string | null,
        has_expired_documents?: boolean
    }) {
        this.store.setExpiryDates(params)
    }
}
